import { actionTypes } from '~/src/features/full-buy/store';

const setAddressData = (addressData: {
    address: {
        value: string,
        flat: string,
        unifiedHouseId?: number,
    },
    isConnectionAvailable: boolean,
    isTariffAvailable: boolean,
} | undefined) => ({
    type: actionTypes.SetAddressData,
    payload: { selectedAddress: addressData },
});

export default setAddressData;
